{
  "branding": {
    "frontdesk-attribution": "با پشتیبانی FrontDesk+",
    "practice-logo": "نشان {{name}}"
  },
  "validation": {
    "required": "این فیلد الزامی است",
    "invalid-url": "لطفاً یک URL معتبر وارد کنید",
    "pin-too-short": "پین باید حداقل 4 کاراکتر باشد",
    "pin-default-rejected": "PIN 0000 استاندارد مجاز نیست. لطفا پین خود را اختصاص دهید.",
    "invalid-kim-address": "Please enter a valid KIM address (e.g. praxis@musterpraxis.kim.telematik)."
  },
  "common": {
    "back": "بازگشت",
    "next": "بعدی",
    "cancel": "لغو",
    "confirm": "تأیید",
    "done": "انجام شد",
    "retry": "تلاش مجدد",
    "clear": "پاک کردن",
    "close": "بستن",
    "verifying": "در حال تأیید...",
    "select": "انتخاب",
    "minutes": "دقیقه",
    "clock": "",
    "gender": {
      "M": "مرد",
      "W": "زن",
      "D": "دیگر",
      "U": "نامشخص"
    },
    "insurance": {
      "GKV": "قانونی",
      "PKV": "خصوصی",
      "SELFPAY": "پرداخت شخصی"
    },
    "scroll-up": "پیمایش به بالا",
    "scroll-down": "پیمایش به پایین"
  },
  "settings": {
    "device-reset": {
      "title": "بازنشانی دستگاه",
      "description": "اتصال مطب، تنظیمات و رمز PIN این دستگاه حذف می‌شوند.",
      "confirmation": "این دستگاه باید دوباره راه‌اندازی شود. تنظیمات SOL و اطلاعات بیماران در inSuite تغییری نمی‌کنند.",
      "cancel": "انصراف",
      "confirm": "اکنون بازنشانی شود"
    },
    "title": "تنظیمات",
    "save": "ذخیره",
    "save-success": "تنظیمات ذخیره شد",
    "save-error": "ذخیره ناموفق بود",
    "load-error": "بارگذاری تنظیمات ناموفق بود",
    "pin": {
      "title": "پین مورد نیاز است",
      "description": "لطفاً پین خود را برای دسترسی به تنظیمات وارد کنید.",
      "error": "پین اشتباه است. لطفاً دوباره تلاش کنید.",
      "backspace": "حذف آخرین رقم"
    },
    "connection": {
      "title": "اتصال",
      "description": "تنظیمات اتصال به سرور Doc-Cirrus Bridge",
      "bridge-url": "آدرس Bridge",
      "device-name": "نام دستگاه",
      "device-name-placeholder": "به عنوان مثال پذیرایی، اتاق 1، کیوسک",
      "device-name-hint": "نام برای شناسایی در داشبورد Bridge",
      "kim-address": "آدرس KIM (اختیاری)",
      "kim-address-placeholder": "praxis@musterpraxis.kim.telematik",
      "kim-address-hint": "This device only. Leave empty to use the practice KIM address.",
      "test": "آزمایش",
      "success": "اتصال موفق",
      "error": "اتصال ناموفق",
      "api-unreachable": "DocCirrus API غیر قابل دسترسی است",
      "status-title": "وضعیت اتصال",
      "status": {
        "api": "API متصل شد",
        "ti": "زیرساخت های مخابراتی",
        "card-reader": "کارتخوان موجود است",
        "medical-card": "کارت مطب پزشک (SMC-B/HBA)"
      },
      "kim-address-consequence": "At Online Check-in the insurer sends the insured person’s data to this address instead of the practice address.",
      "kim-address-practice": "Practice address",
      "kim-address-confirm-title": "Change the KIM address for this device?",
      "kim-address-confirm-description": "At Online Check-in the insurer will send the insured person’s data to this address from now on.",
      "kim-address-confirm-previous": "Current",
      "kim-address-confirm-next": "New",
      "kim-address-confirm-cancel": "Cancel",
      "kim-address-confirm-accept": "Change address",
      "sol-token": "توکن Sol (از inSuite)",
      "sol-token-hint": "از بخش مدیریت Bridge در inSuite کپی کنید. برای اتصال لازم است.",
      "sol-token-show": "نمایش توکن",
      "sol-token-hide": "پنهان کردن توکن",
      "bridge-unreachable": "Bridge در دسترس نیست. لطفاً نشانی و پورت را بررسی کنید.",
      "diagnostic-id": "شناسه عیب‌یابی: {{id}}",
      "scan-qr": "اسکن کد QR",
      "scan-title": "اسکن کد QR مربوط به Bridge",
      "scan-manual": "ورود دستی"
    },
    "terminal": {
      "title": "کارت‌خوان",
      "description": "انتخاب کارت‌خوان برای زیرساخت تله‌ماتیک",
      "select": "انتخاب ترمینال",
      "select-placeholder": "ترمینال را انتخاب کنید...",
      "loading": "در حال بارگذاری ترمینال‌ها...",
      "none-available": "ترمینالی در دسترس نیست",
      "none-found": "ترمینالی یافت نشد",
      "found": "{{count}} ترمینال یافت شد",
      "connect-hint": "ابتدا به سرور bridge متصل شوید تا ترمینال‌ها بارگذاری شوند.",
      "found-count": "کارت‌خوان‌های یافت‌شده: {{count}}",
      "refresh": "بارگذاری دوباره کارت‌خوان‌ها"
    },
    "practice": {
      "title": "مطب پزشک",
      "description": "اطلاعات مربوط به مطب پزشک شما",
      "name": "نام مطب پزشک",
      "name-placeholder": "مثال: دکتر احمد محمدی",
      "welcome-message": "پیام خوش‌آمدگویی",
      "welcome-placeholder": "مثلاً: به مطب ما خوش آمدید",
      "scheduler-available": "زمانبندی را فعال کنید",
      "scheduler-available-description": "به بیماران اجازه دهید از طریق پایانه سلف سرویس نوبت رزرو کنند",
      "prescription-available": "خدمات نسخه را فعال کنید",
      "prescription-available-description": "Patients can request repeat prescriptions at the self-service terminal. The practice reviews every request.",
      "welcome-hint": "خالی بگذارید تا خوشامدگویی به زبان بیمار نمایش داده شود. متن خودتان در همه زبان‌ها بدون تغییر نمایش داده می‌شود."
    },
    "patient-info": {
      "eyebrow": "Patient information review",
      "description": "Applies practice-wide to every FrontDesk+ terminal and is enforced by the server.",
      "enabled": "Show the review after reading the health card",
      "phone": "Review telephone numbers",
      "email": "Review email addresses",
      "hausarzt": "Review primary physician",
      "selection-required": "Select at least one item to review.",
      "save": "Save review setting",
      "saved": "Review settings saved.",
      "conflict": "The setting changed in the meantime. The current version has been loaded.",
      "save-error": "The review settings could not be saved.",
      "unavailable": "The practice-wide setting is currently unavailable.",
      "scope": "Practice-wide · Server",
      "scope-description": "Stored on the practice server and enforced for all terminals.",
      "sentence-off": "The review is switched off. Patients are not asked about their contact details at the terminal.",
      "last-saved": "Last saved on the server: {{value}}",
      "never-saved": "Never saved on the server.",
      "last-saved-all": "برای همه دستگاه‌ها ذخیره شد در {{value}}",
      "never-saved-default": "تنظیم پیش‌فرض، هنوز تغییر نکرده است."
    },
    "anamnesis": {
      "title": "تاریخچه پزشکی دیجیتال",
      "description": "یک پیوند و QR code را به ارائه‌دهنده سابقه پزشکی شما پس از ورود نشان می‌دهد.",
      "enabled": "نمایش پیوند سابقه پزشکی پس از ورود",
      "enabled-description": "یک پیوند و QR code را به ارائه‌دهنده تاریخچه پزشکی شما پس از یک بررسی کامل نشان می‌دهد، برای مثال Nelly.",
      "url": "لینک ارائه دهنده تاریخچه پزشکی",
      "url-hint": "پیوند ثابت و برای همه بیماران یکسان است.",
      "preview-label": "پیش نمایش صفحه تکمیل",
      "preview-note": "پیوند ثابت و برای همه بیماران یکسان است.",
      "url-first": "برای روشن کردن، ابتدا یک پیوند معتبر وارد کنید."
    },
    "appearance": {
      "title": "ظاهر",
      "description": "سفارشی‌سازی رابط کاربری",
      "language": "زبان",
      "default-kiosk-language": "زبان پیش فرض بیمار",
      "default-kiosk-language-hint": "زبانی که جلسات کیوسک جدید برای بیماران شروع می شود.",
      "voice-over-volume": "صدای بیش از حد",
      "voice-over-hint": "صدای دستیار صوتی را برای دسترسی کنترل می کند.",
      "language-first": "نمایش انتخاب زبان در آغاز جلسه"
    },
    "security": {
      "title": "امنیت",
      "description": "پین برای دسترسی به تنظیمات",
      "pin": "پین",
      "pin-hint": "4-8 digits. At least 4 digits, and not 0000."
    },
    "eyebrow": "مدیریت کیوسک",
    "nav": {
      "general": "عمومی",
      "flows": "قابلیت‌ها",
      "anamnese": "شرح حال دیجیتال",
      "device": "دستگاه و اتصال"
    },
    "flows": {
      "title": "قابلیت‌های روی پایانه"
    },
    "language": {
      "title": "زبان و خواندن با صدا",
      "description": "زبان و خواندن با صدا برای بیماران روی این دستگاه."
    }
  },
  "self-service": {
    "title": "خدمات خودکار",
    "step-progress": "مرحله {{current}} / {{total}}",
    "flows": {
      "checkin": "ثبت‌نام",
      "scheduler": "رزرو نوبت",
      "prescription": "نسخه ها",
      "locations": "نقشه مکان",
      "emergency": "اورژانس"
    },
    "audio-guide": {
      "on": "صدا روشن",
      "off": "صدا خاموش",
      "replay": "پخش دوباره راهنما",
      "replay-unavailable": "راهنمای صوتی برای پخش دوباره موجود نیست"
    },
    "language-selector": {
      "title": "انتخاب زبان",
      "description": "لطفاً زبان مورد نظر خود را انتخاب کنید"
    },
    "settings": "تنظیمات",
    "start": {
      "welcome": "خوش آمدید",
      "subtitle": "لطفاً یک گزینه انتخاب کنید",
      "check-in-label": "مسیر اصلی",
      "check-in-cta": "ثبت‌نام",
      "check-in-description": "قبلاً نوبت دارید؟ اینجا ثبت‌نام کنید.",
      "check-in-hint": "کارت خود را آماده کنید",
      "scheduler-label": "جدید",
      "scheduler-cta": "رزرو نوبت",
      "scheduler-description": "نوبت جدید رزرو کنید.",
      "location-plan": "نقشه مکان",
      "location-plan-description": "مسیر اتاق درمان را پیدا کنید.",
      "prescription-label": "نسخه",
      "prescription-cta": "نسخه و سفارش",
      "prescription-description": "نسخه ها را مشاهده کنید یا مجدداً سفارش دهید.",
      "emergency-cta": "هشدار اضطراری محلی",
      "emergency-description": "فقط روی این دستگاه صدا می‌دهد و درخواست کمک نمی‌کند.",
      "tap-to-start": "برای شروع ضربه بزنید"
    },
    "offline": {
      "banner-title": "اعلام حضور موقتاً در دسترس نیست",
      "banner-message": "لطفاً برای کمک با کارکنان پذیرش صحبت کنید.",
      "emergency-available": "هشدار محلی همچنان در دسترس است. این هشدار درخواست کمک نمی‌کند.",
      "flow-disabled": "به طور موقت در دسترس نیست"
    },
    "readability": {
      "toggle-label": "حالت خواندن",
      "on": "حالت خواندن",
      "off": "حالت خواندن"
    },
    "reset-overlay": {
      "timeout-title": "جلسه به پایان رسید",
      "timeout-subtitle": "زمان شما تمام شده است اطلاعات شما امن است",
      "offline-title": "اتصال قطع شد",
      "offline-subtitle": "ارتباط قطع شد. لطفا با کارکنان پذیرش صحبت کنید.",
      "interruption-title": "جلسه به پایان رسید",
      "interruption-subtitle": "جلسه شما با خیال راحت به پایان رسیده است.",
      "completion-title": "متشکرم",
      "completion-subtitle": "درخواست شما با موفقیت تکمیل شد.",
      "reassurance": "اطلاعات شخصی شما در این دستگاه ذخیره نمی شود.",
      "auto-dismiss": "بازگشت به شروع در {{seconds}} ثانیه...",
      "dismiss": "برو برای شروع"
    },
    "timed-terminal": {
      "countdown": "بازگشت خودکار در {{seconds}} ثانیه",
      "countdown-outcome": "این ترمینال به طور خودکار به صفحه شروع باز می گردد.",
      "more-time": "زمان بیشتر",
      "extended": "زمان تمدید شد"
    },
    "scheduler": {
      "questionnaire": {
        "language-unavailable": "این پرسش‌ها به زبان شما در دسترس نیستند. لطفاً یکی از زبان‌های ارائه‌شده را انتخاب کنید یا به پذیرش مراجعه کنید.",
        "alternatives": "نوبت‌های جایگزین",
        "loading": "در حال بارگذاری پرسش‌ها…",
        "reception-fallback": "لطفاً به پذیرش مراجعه کنید.",
        "error-title": "سؤالات بارگیری نشد",
        "language-unavailable-lead": "این سؤالات به زبان شما در دسترس نیست.",
        "language-unavailable-title": "لطفاً یکی از این زبان‌ها را انتخاب کنید",
        "language-unavailable-body": "یا از پذیرش کمک بخواهید."
      },
      "start": {
        "title": "رزرو نوبت",
        "subtitle": "نوبت مورد نظر خود را در چند مرحله رزرو کنید",
        "welcome": "به رزرو نوبت خوش آمدید",
        "description": "ما شما را در فرآیند رزرو راهنمایی خواهیم کرد",
        "cta": "اکنون نوبت رزرو کنید"
      },
      "patient-id": {
        "title": "شناسایی",
        "subtitle": "لطفاً خود را معرفی کنید",
        "mode-card": "با کارت",
        "mode-search": "جستجو",
        "mode-create": "ایجاد جدید",
        "insert-card": "لطفاً کارت بیمه خود را وارد کنید",
        "reading-card": "در حال خواندن کارت...",
        "simulate-card": "شبیه‌سازی کارت",
        "multiple-matches": "چندین بیمار یافت شد. از داده‌های کارت استفاده می‌شود.",
        "search-placeholder": "نام یا شماره بیمه...",
        "searching": "در حال جستجو...",
        "no-results": "نتیجه‌ای یافت نشد",
        "first-name": "نام",
        "last-name": "نام خانوادگی",
        "dob": "تاریخ تولد",
        "insurance": "بیمه",
        "continue": "ادامه",
        "creating": "ایجاد بیمار...",
        "patient-created": "بیمار با موفقیت ایجاد شد!",
        "create-error": "نمی توان بیمار را ایجاد کرد."
      },
      "appointment-type": {
        "title": "انتخاب نوع نوبت",
        "subtitle": "لطفاً دلیل مراجعه خود را انتخاب کنید",
        "loading": "در حال بارگذاری انواع نوبت...",
        "no-types": "نوع نوبتی در دسترس نیست",
        "error": "بارگذاری انواع نوبت ناموفق بود. لطفاً دوباره تلاش کنید.",
        "no-bookable": "این نوع نوبت ها در حال حاضر از طریق کیوسک قابل رزرو نیستند. لطفا به پذیرش مراجعه کنید یا تلفنی نوبت بگیرید.",
        "disabled-default": "لطفا این نوبت را مستقیما از پذیرش یا به صورت تلفنی هماهنگ کنید.",
        "disabled-footer": "فقط پذیرش/تلفن",
        "lead": "چه نوع نوبتی می‌خواهید رزرو کنید؟",
        "duration": "حدود {{minutes}} دقیقه",
        "empty-title": "در حال حاضر رزرو نوبت در اینجا ممکن نیست",
        "none-bookable-title": "این نوبت‌ها را نمی‌توانید اینجا رزرو کنید",
        "none-bookable-body": "لطفاً از پذیرش بپرسید یا با ما تماس بگیرید."
      },
      "types": {
        "general": "مشاوره عمومی",
        "general-desc": "برای شکایات و سؤالات عمومی",
        "checkup": "معاینه پیشگیرانه",
        "checkup-desc": "معاینات سلامت منظم",
        "vaccination": "واکسیناسیون",
        "vaccination-desc": "زمان‌بندی واکسیناسیون",
        "followup": "پیگیری",
        "followup-desc": "نوبت کنترل",
        "prescription": "نسخه",
        "prescription-desc": "دریافت نسخه"
      },
      "slot-selection": {
        "title": "انتخاب نوبت",
        "subtitle": "لطفاً یک نوبت موجود انتخاب کنید",
        "loading": "در حال بارگذاری نوبت‌های موجود...",
        "no-slots": "نوبتی موجود نیست",
        "no-appointment-type": "نوع نوبت انتخاب نشده است",
        "error": "بارگذاری بازه‌های موجود ناموفق بود. لطفاً دوباره تلاش کنید.",
        "quick-select": "نوبت‌های موجود بعدی:",
        "select-date": "یا یک تاریخ انتخاب کنید:",
        "times-for": "{{date}}",
        "available": "موجود",
        "unavailable": "بازه‌ای وجود ندارد",
        "slots": "بازه‌ها",
        "select-time-hint": "برای رزرو نوبت خود روی یک زمان ضربه بزنید",
        "week-short": "هفته",
        "weekday-mon": "دوشنبه",
        "weekday-tue": "سه‌شنبه",
        "weekday-wed": "چهارشنبه",
        "weekday-thu": "پنج‌شنبه",
        "weekday-fri": "جمعه",
        "weekday-sat": "شنبه",
        "weekday-sun": "یکشنبه",
        "period-morning": "صبح",
        "period-midday": "ظهر",
        "period-afternoon": "بعدازظهر",
        "period-evening": "عصر",
        "period-morning-short": "صبح",
        "period-midday-short": "ظهر",
        "period-afternoon-short": "ب.ظ",
        "period-evening-short": "عصر",
        "period-dots-legend": "در دسترس بودن زمان",
        "filter-hint": "فیلتر بر اساس زمان‌های ترجیحی:",
        "or-choose-below": "یا زیر را انتخاب کنید",
        "no-slots-period": "بدون اسلات",
        "show-all": "نمایش همه",
        "free": "رایگان",
        "your-selection": "انتخاب شما",
        "oclock": "ساعت",
        "choose-slot": "اسلات را انتخاب کنید",
        "choose-day": "انتخاب روز",
        "choose-day-first": "لطفاً ابتدا یک روز انتخاب کنید",
        "times-heading": "زمان‌های آزاد در {{date}}",
        "time-value": "{{time}}",
        "empty-title": "نوبت آزادی در {{month}} نیست",
        "empty-body": "ماه بعد را ببینید یا از پذیرش بپرسید – با کمال میل کمک می‌کنیم.",
        "next-month": "ماه بعد",
        "previous-month": "ماه قبل"
      },
      "confirmation": {
        "patient-responses": "پاسخ‌های شما",
        "review-loading": "در حال بررسی خلاصه…",
        "review-unavailable": "خلاصه در دسترس نیست. لطفاً دوباره تلاش کنید یا از پذیرش بپرسید.",
        "check-booking": "بررسی وضعیت رزرو",
        "title": "تأیید نوبت",
        "subtitle": "لطفاً رزرو خود را بررسی کنید",
        "patient": "بیمار",
        "datetime": "تاریخ و زمان",
        "booking": "در حال رزرو...",
        "confirm": "رزرو نوبت",
        "heading": "آیا این درست به نظر می رسد؟",
        "lead": "لطفا قرار ملاقات خود را تایید کنید.",
        "appointment": "قرار ملاقات",
        "insured-via": "بیمه شده از طریق",
        "description-label": "یادداشت برای مطب (اختیاری)",
        "description-hint": "اگر هنگام تعیین وقت یا پذیرش باید نکته‌ای را در نظر بگیریم، به ما اطلاع دهید.",
        "description-placeholder": "مثلاً محدودیت حرکتی، همراه، نکات مهم",
        "description-too-long": "لطفاً یادداشت را به حداکثر ۵۰۰ نویسه کوتاه کنید.",
        "summary": "خلاصه",
        "change": "تغییر دهید",
        "book-binding": "قرار ملاقات رزرو کنید",
        "cancel": "لغو کنید",
        "type-label": "نوع نوبت",
        "datetime-value": "{{date}} ساعت {{time}}",
        "name-label": "نام",
        "insurance-label": "بیمه",
        "insurance-GKV": "بیمه درمانی قانونی",
        "insurance-PKV": "بیمه درمانی خصوصی",
        "insurance-SELFPAY": "پرداخت شخصی",
        "change-time": "تغییر نوبت",
        "description-free-text": "توضیحات دیگر (اختیاری)",
        "note-wheelchair": "از ویلچر استفاده می‌کنم",
        "note-companion": "با همراه می‌آیم",
        "note-interpreter": "به مترجم نیاز دارم"
      },
      "done": {
        "title": "نوبت رزرو شد!",
        "label": "رزرو شده است",
        "subtitle": "نوبت شما با موفقیت رزرو شد.",
        "date": "تاریخ",
        "time": "زمان",
        "booking-id": "شماره رزرو",
        "qr-hint": "به تقویم اضافه کنید",
        "qr-description": "این کد QR را با دوربین گوشی هوشمند خود اسکن کنید تا نوبت را به برنامه تقویم خود اضافه کنید",
        "auto-redirect": "به زودی به صفحه اصلی هدایت خواهید شد...",
        "auto-redirect-countdown": "بازگشت به ابتدا در {{seconds}} ثانیه...",
        "back-to-start": "بازگشت به ابتدا",
        "print-button": "چاپ برگه نوبت",
        "print-preparing": "در حال آماده‌سازی نمای چاپ…",
        "print-error": "برگه نوبت باز نشد. لطفاً دوباره تلاش کنید یا از پذیرش کمک بخواهید.",
        "print-returned": "نمای چاپ سیستم بسته شد. در صورت نیاز می‌توانید نسخه دیگری درخواست کنید.",
        "print-title": "نوبت شما",
        "print-location": "مکان",
        "print-map-hint": "باز کردن مکان در تلفن",
        "print-error-v2": "برگه نوبت باز نشد. لطفاً دوباره تلاش کنید یا از پذیرش بپرسید."
      },
      "error": {
        "assistance-info": "نتوانستیم رزرو شما را تأیید کنیم. شاید نوبت شما قبلاً رزرو شده باشد. لطفاً از پذیرش بپرسید.",
        "pending-title": "رزرو تأیید نشد",
        "pending-info": "نتوانستیم رزرو شما را تأیید کنیم. شاید نوبت شما قبلاً رزرو شده باشد. لطفاً دوباره بررسی کنید یا از پذیرش بپرسید.",
        "title": "رزرو ناموفق بود",
        "subtitle": "نوبت رزرو نشد.",
        "info": "لطفاً دوباره تلاش کنید یا از پذیرش بپرسید."
      },
      "phase": {
        "identify": "ورود",
        "choose": "انتخاب زمان",
        "confirm": "تأیید"
      }
    },
    "prescription": {
      "start": {
        "title": "نسخه و سفارش",
        "subtitle": "کارت بیمه خود را برای مشاهده نسخه ها یا سفارش پر کردن مجدد وارد کنید.",
        "button": "درج کارت"
      },
      "card-check": {
        "loading": "در حال بارگیری کارتخوان...",
        "no-terminal": "کارتخوان پیکربندی نشده است",
        "no-terminal-hint": "لطفا برای کمک با کارکنان تماس بگیرید.",
        "insert-card": "لطفا کارت خود را وارد کنید",
        "insert-card-hint": "کارت بیمه خود را در دستگاه کارتخوان قرار دهید.",
        "card-detected": "کارت شناسایی شد",
        "reading": "کارت مطالعه...",
        "reading-hint": "لطفا یک لحظه صبر کنید.",
        "error": "خطا در خواندن کارت",
        "retry": "دوباره امتحان کنید",
        "manual-lookup": "بدون کارت ادامه دهید",
        "load-error": "کارتخوان بارگیری نشد",
        "read-error": "کارت خوانده نشد"
      },
      "patient-selection": {
        "title": "بیمار را انتخاب کنید",
        "subtitle": "چندین بیمار پیدا شد. لطفا نام خود را انتخاب کنید",
        "try-again": "دوباره امتحان کنید",
        "try-again-hint": "دوباره کارت را وارد کنید"
      },
      "list": {
        "title": "نسخه های شما",
        "for-patient": "نسخه برای {{name}}",
        "loading": "در حال بارگیری نسخه ها...",
        "error-title": "خطای بارگذاری",
        "fetch-error": "نسخه ها بارگیری نشدند",
        "back-home": "بازگشت به شروع",
        "done": "انجام شد"
      },
      "detail": {
        "prescription-info": "اطلاعات نسخه",
        "date": "تاریخ",
        "prescriber": "تجویز کننده",
        "comment": "توجه داشته باشید",
        "medications": "داروها",
        "form": "فرم",
        "pack-size": "اندازه بسته",
        "manufacturer": "سازنده",
        "loading": "در حال بارگیری نسخه...",
        "fetch-error": "جزئیات نسخه بارگیری نشد",
        "back-to-list": "بازگشت به فهرست",
        "print": "چاپ کنید"
      },
      "types": {
        "public": "نسخه عمومی",
        "private": "نسخه خصوصی",
        "long-term": "نسخه طولانی مدت",
        "btm": "نسخه مواد مخدر",
        "g": "نسخه سبز",
        "t": "نسخه تی"
      },
      "no-patient": {
        "title": "بیمار پیدا نشد",
        "subtitle": "متاسفانه هیچ بیمار برای این کارت پیدا نشد. لطفا برای کمک با کارکنان تماس بگیرید.",
        "try-again": "دوباره امتحان کنید",
        "back-home": "بازگشت به شروع",
        "title-v2": "اطلاعات مطابقی پیدا نشد",
        "subtitle-v2": "نتوانستیم شما را پیدا کنیم. لطفاً دوباره تلاش کنید یا از پذیرش بپرسید."
      },
      "done": {
        "title": "متشکرم",
        "subtitle": "شما ممکن است اکنون یک صندلی بنشینید. اگر سوالی دارید، لطفا با کارکنان تماس بگیرید.",
        "no-prescriptions-title": "بدون نسخه در پرونده",
        "no-prescriptions-subtitle": "هیچ نسخه فعالی برای شما پیدا نکردیم. اگر انتظار دارید، لطفا با کارکنان پذیرش تماس بگیرید.",
        "error-title": "خطایی رخ داده است",
        "error-subtitle": "لطفا برای راهنمایی بیشتر با کارکنان تماس بگیرید.",
        "auto-redirect": "تغییر مسیر خودکار در {{seconds}} ثانیه",
        "finish": "بازگشت به شروع"
      },
      "hub": {
        "title": "نسخه های شما",
        "for-patient": "نسخه برای {{name}}",
        "loading": "در حال بارگیری نسخه ها...",
        "error-title": "خطای بارگذاری",
        "fetch-error": "نسخه ها بارگیری نشد",
        "back-home": "بازگشت به شروع",
        "done": "انجام شد",
        "order-button": "سفارش نسخه",
        "existing-prescriptions": "نسخه های فعلی شما",
        "no-prescriptions": "هیچ نسخه فعالی یافت نشد."
      },
      "patient-lookup": {
        "title": "بیمار را پیدا کنید",
        "subtitle": "نام و تاریخ تولد خود را وارد کنید.",
        "last-name": "نام خانوادگی",
        "first-name": "نام",
        "date-of-birth": "تاریخ تولد",
        "lastname": "نام خانوادگی",
        "lastname-placeholder": "نام خانوادگی شما",
        "firstname": "نام",
        "firstname-placeholder": "نام کوچک شما",
        "dob": "تاریخ تولد",
        "search": "جستجو کنید",
        "searching": "در حال جستجو...",
        "search-error": "خطای جستجو: {{message}}",
        "no-match": "بیمار پیدا نشد لطفا اطلاعات خود را بررسی کنید.",
        "error": "خطای جستجو لطفا دوباره امتحان کنید.",
        "found": "بیمار پیدا شد",
        "confirm": "تایید کنید",
        "ambiguous": "مسابقات متعدد",
        "ambiguous-hint-firstname": "لطفاً نام کوچک خود را نیز وارد کنید تا جستجو را اصلاح کنید.",
        "ambiguous-hint-additional": "لطفا اطلاعات خود را بررسی کنید یا با کارکنان تماس بگیرید.",
        "not-found": "بیمار پیدا نشد",
        "not-found-hint": "هیچ بیمار با این جزئیات پیدا نشد.",
        "not-found-action": "دوباره امتحان کنید"
      },
      "manual-identification": {
        "unverified": "هویت شما با کارت بیمه سلامت تأیید نشده است. مطب پیش از رسیدگی، اطلاعات و درخواست شما را بررسی می‌کند."
      },
      "medication-selection": {
        "title": "درخواست نسخه کنید",
        "subtitle": "مطب پزشک درخواست شما را بررسی می‌کند. پس از تأیید، eRx در برنامه e-prescription شما آماده خواهد بود.",
        "back": "برگشت",
        "submit": "به بررسی ادامه دهید",
        "reason-title": "چرا به نسخه نیاز دارید؟",
        "reason-hint": "به مطب پزشک کمک می‌کند درخواست شما را ارزیابی کند.",
        "reason-validation": "لطفا دلیل انتخاب کنید",
        "reason-schmerzen": "درد",
        "reason-entzuendung": "التهاب",
        "reason-nachsorge": "پس از جراحی / روش",
        "reason-allergie": "آلرژی / واکنش",
        "reason-chronisch": "وضعیت مزمن",
        "reason-anderes": "یه چیز دیگه",
        "medications-title": "کدام داروها؟",
        "request-hint": "آنچه را که نیاز دارید شرح دهید، یا نسخه قبلی را که می خواهید تمدید کنید نام ببرید.",
        "request-placeholder": "به عنوان مثال ایبوپروفن 600 میلی گرم مثل دفعه قبل",
        "request-validation": "لطفاً توضیح دهید که چه دارویی نیاز دارید.",
        "history-title": "نسخه های قبلی",
        "history-hint": "یک ورودی برای تکمیل درخواست خود اضافه کنید.",
        "history-loading": "در حال بارگیری نسخه های قبلی...",
        "history-error": "نسخه های قبلی بارگیری نشدند.",
        "history-add": "اضافه کنید",
        "history-added": "اضافه شد",
        "history-date": "آخرین: {{date}}",
        "history-request-line": "تمدید: {{medicationName}}",
        "urgency-title": "چقدر فوری است؟",
        "urgency-hint": "به مطب پزشک کمک می‌کند اولویت را تعیین کند.",
        "urgency-soon": "فوری",
        "urgency-soon-meta": "در اسرع وقت",
        "urgency-tomorrow": "به زودی",
        "urgency-tomorrow-meta": "در چند روز آینده",
        "urgency-week": "این هفته",
        "urgency-week-meta": "بدون فشار زمانی",
        "lead": "مطب درخواست شما را بررسی می‌کند. پس از تأیید، نسخه الکترونیکی خود را در برنامه نسخه الکترونیکی یا روی کارت بیمه درمانی پیدا می‌کنید.",
        "history-hint-v2": "برای افزودن، روی یک نسخه قبلی بزنید.",
        "history-retry": "بارگیری دوباره"
      },
      "request-review": {
        "title": "سفارش بررسی",
        "subtitle": "لطفا درخواست نسخه خود را بررسی کنید.",
        "request-label": "دارو درخواست کرد",
        "selected-medications": "داروهای انتخابی",
        "free-text-medications": "داروهای اضافی",
        "freetext-label": "دیگر",
        "quarterly-warning": "کارت بیمه شما در این سه‌ماهه خوانده نشده است. مطب پزشک ممکن است با شما تماس بگیرد.",
        "egk-warning": "کارت بیمه شما در این سه‌ماهه خوانده نشده است. مطب پزشک ممکن است با شما تماس بگیرد.",
        "submit": "ارسال کنید",
        "submitting": "در حال ارسال...",
        "submit-error": "درخواست ارسال نشد. لطفا دوباره امتحان کنید.",
        "back": "برگشت",
        "reason-label": "دلیل",
        "urgency-label": "فوریت",
        "completion-email-choice": "می‌خواهم وقتی مطب درخواست من را بررسی کرد، ایمیل دریافت کنم.",
        "completion-email-label": "نشانی ایمیل",
        "completion-email-placeholder": "name@example.com",
        "completion-email-hint": "فقط برای این پیام یک‌باره. نشانی در اطلاعات اصلی ذخیره نمی‌شود.",
        "completion-email-invalid": "لطفاً یک نشانی ایمیل معتبر وارد کنید.",
        "egk-proof-required": "درخواست نسخه فقط پس از خواندن موفق کارت بیمه امکان پذیر است. لطفا به کارکنان مراجعه کنید.",
        "title-v2": "بررسی درخواست",
        "completion-email-hint-v2": "این نشانی فقط برای همین یک پیام استفاده می‌شود."
      },
      "confirmation": {
        "title": "درخواست ارسال شد",
        "subtitle": "درخواست نسخه شما با موفقیت ارسال شد.",
        "success-title": "درخواست ارسال شد",
        "success-subtitle": "درخواست نسخه شما با موفقیت ارسال شد.",
        "estimated-time": "نسخه شما تقریباً با {{time}} آماده خواهد شد.",
        "info": "می توانید نسخه خود را با کارت بیمه یا برنامه eRezept از داروخانه دریافت کنید.",
        "auto-redirect": "تغییر مسیر خودکار در {{seconds}} ثانیه",
        "back-to-start": "بازگشت به شروع",
        "handling-label": "Handled by the practice",
        "next-steps": "مطب درخواست شما را بررسی می‌کند. پس از تأیید می‌توانید نسخه الکترونیکی را در داروخانه با کارت بیمه درمانی یا برنامه نسخه الکترونیکی دریافت کنید."
      },
      "phase": {
        "identify": "ورود",
        "request": "درخواست",
        "review": "بررسی"
      }
    },
    "check-in": {
      "flow-label": "ثبت نام",
      "has-appointment": {
        "eyebrow": "قرار ملاقات",
        "title": "آیا نوبت دارید؟",
        "subtitle": "لطفاً یک گزینه انتخاب کنید",
        "yes-label": "بله",
        "yes": "بله، نوبت دارم",
        "yes-description": "می‌خواهم برای نوبتم ثبت‌نام کنم.",
        "yes-hint": "سریع ترین مسیر",
        "unsure-label": "شاید",
        "unsure": "مطمئن نیستم",
        "unsure-description": "ما برای شما بررسی خواهیم کرد.",
        "unsure-hint": "ما شما را جستجو خواهیم کرد",
        "no-label": "خیر",
        "no": "خیر، بدون نوبت",
        "no-description": "نوبت ندارم.",
        "no-hint": "پیاده روی"
      },
      "card-check": {
        "eyebrow": "کارت بیمه",
        "title": "خواندن کارت بیمه",
        "subtitle": "لطفاً کارت بیمه خود را در کارت‌خوان قرار دهید",
        "insert-title": "کارت بیمه خود را در دستگاه کارت‌خوان قرار دهید.",
        "insert-detail": "ما جزئیات شما را به طور خودکار می خوانیم - شما نیازی به انجام کار دیگری ندارید.",
        "other-ways": "راه های دیگر",
        "no-card-hint": "اگر کارت خود را در حال حاضر همراه ندارید.",
        "pkv-hint": "از QR code با برنامه بیمه خود استفاده کنید.",
        "loading": "در حال بارگذاری تنظیمات...",
        "no-terminal": "کارت‌خوان پیکربندی نشده است. لطفاً با کارکنان تماس بگیرید.",
        "checking": "در حال بررسی کارت‌ها...",
        "insert-prompt": "لطفاً کارت را وارد کنید...",
        "card-detected": "کارت شناسایی شد! آماده خواندن.",
        "read-card": "خواندن کارت",
        "simulate-insert": "شبیه‌سازی کارت",
        "reading": "در حال خواندن کارت...",
        "error": "خواندن کارت ناموفق بود. لطفاً دوباره تلاش کنید.",
        "read-error": "خواندن داده‌های کارت ناموفق بود. لطفاً دوباره تلاش کنید.",
        "settings-error": "بارگذاری تنظیمات ناموفق بود. لطفاً دوباره تلاش کنید.",
        "no-card-prompt": "کارت ندارید؟",
        "no-card-action": "جستجوی دستی",
        "connection-warning": "مشکلات اتصال با کارت خوان لطفا صبر کنید...",
        "pkv-prompt": "بیمه خصوصی؟ Online Check-in",
        "pkv-instruction": "این QR code را با برنامه بیمه درمانی خصوصی خود اسکن کنید تا داده های خود را به صورت دیجیتالی منتقل کنید.",
        "pkv-continue": "به ثبت نام دستی ادامه دهید",
        "unreadable-title": "Card detected, but no insurance data could be read.",
        "unreadable-body": "Please try again or go to the reception desk. You can also check in without your card.",
        "unreadable-help": "لطفاً دوباره امتحان کنید یا بدون کارت پذیرش شوید. پذیرش با کمال میل کمک می‌کند.",
        "title-pkv": "پذیرش با برنامه",
        "title-reading": "کارت شما در حال خوانده شدن است …",
        "title-unreadable": "کارت خوانده نشد",
        "title-no-terminal": "پذیرش بدون کارت",
        "no-terminal-body": "کارت‌خوان فعلاً در دسترس نیست. لطفاً بدون کارت پذیرش شوید یا به پذیرش مراجعه کنید.",
        "reading-detail": "لطفاً کارت را در کارت‌خوان بگذارید. فقط یک لحظه طول می‌کشد.",
        "other-ways-title": "راه‌های دیگر",
        "no-card-title": "پذیرش بدون کارت",
        "pkv-prompt-title": "بیمه خصوصی دارید؟",
        "pkv-prompt-hint": "پذیرش با برنامه بیمه درمانی خصوصی شما",
        "pkv-close": "با کارت پذیرش شوم",
        "pkv-instruction-app": "برنامه بیمه درمانی خصوصی خود را باز کنید و این کد را اسکن کنید. اطلاعات شما مستقیم به ما می‌رسد."
      },
      "patient-selection": {
        "title": "انتخاب بیمار",
        "subtitle": "چندین بیمار یافت شد. لطفاً خود را انتخاب کنید.",
        "firstname-label": "نام کوچک شما",
        "firstname-placeholder": "نام کوچک را وارد کنید...",
        "confirm-button": "تایید کنید",
        "no-match": "هیچ بیمار مشابهی پیدا نشد لطفا برای راهنمایی به میز پذیرش مراجعه کنید.",
        "still-ambiguous": "چند مسابقه باقی مانده است. لطفا برای راهنمایی به میز پذیرش مراجعه کنید.",
        "select-error": "شناسایی بیمار ناموفق بود. لطفا دوباره امتحان کنید.",
        "staff-assist": "به پذیرش بروید",
        "title-v2": "یک سؤال کوتاه",
        "subtitle-v2": "برای اطمینان، لطفاً نام کوچک خود را وارد کنید.",
        "no-match-v2": "با این نام شما را پیدا نکردیم. لطفاً املا را بررسی کنید یا به پذیرش مراجعه کنید.",
        "still-ambiguous-v2": "هنوز نتوانستیم شما را به‌طور قطعی پیدا کنیم. لطفاً به پذیرش مراجعه کنید.",
        "select-error-v2": "متأسفانه انجام نشد. لطفاً دوباره امتحان کنید."
      },
      "card-checkin": {
        "title": "تأیید ثبت‌نام",
        "subtitle": "داده‌های شما با موفقیت خوانده شد.",
        "confirm": "تأیید ثبت‌نام"
      },
      "register-from-card": {
        "title": "ثبت‌نام جدید",
        "subtitle": "شما هنوز در سیستم ما نیستید. می‌خواهید ثبت‌نام کنید؟",
        "card-data": "داده های کارت",
        "create": "ثبت‌نام",
        "create-error": "ثبت نام انجام نشد لطفاً دوباره امتحان کنید یا از کارکنان کمک بخواهید.",
        "staff-assist": "با کارکنان تماس بگیرید",
        "no-card-data-title": "داده کارت وجود ندارد",
        "no-card-data": "خواندن داده ها از کارت شما امکان پذیر نیست.",
        "insurance-verified": "بیمه تایید شده: {{insurer}}",
        "insurer-missing": "The card does not contain a cost-carrier identifier. Registration via the card is not possible. Please go to the reception desk.",
        "title-v2": "اطلاعات شما از کارت",
        "subtitle-v2": "لطفاً اطلاعات خود را بررسی کنید. اگر چیزی درست نیست، روی «تغییر» بزنید.",
        "create-v2": "تأیید اطلاعات",
        "create-error-v2": "متأسفانه پذیرش انجام نشد. لطفاً دوباره امتحان کنید یا به پذیرش مراجعه کنید.",
        "insurer-missing-v2": "روی کارت شما اطلاعات بیمه درمانی وجود ندارد. لطفاً به پذیرش مراجعه کنید.",
        "edit": "تغییر",
        "name": "نام",
        "insurer": "بیمه درمانی"
      },
      "patient-lookup": {
        "title": "جستجوی بیمار",
        "subtitle": "لطفاً نام یا شماره بیمه خود را وارد کنید.",
        "lastname": "نام خانوادگی",
        "lastname-placeholder": "نام خانوادگی شما",
        "dob": "تاریخ تولد",
        "firstname": "نام کوچک",
        "firstname-placeholder": "نام کوچک شما",
        "search": "جستجو کنید",
        "searching": "در حال جستجو...",
        "search-placeholder": "نام یا شماره بیمه...",
        "results-placeholder": "نتایج جستجو اینجا نمایش داده می‌شود",
        "found": "بیمار پیدا شد!",
        "confirm-identity": "لطفاً تأیید کنید که شما بیمار نشان داده شده هستید.",
        "confirm-button": "این من هستم",
        "ambiguous-firstname": "چندین بیمار پیدا شد. لطفا نام خود را وارد کنید",
        "ambiguous-additional": "چندین بیمار پیدا شد. لطفا با کارکنان تماس بگیرید.",
        "disambiguation-hint": "این به ما کمک می کند تا شما را به وضوح شناسایی کنیم.",
        "not-found": "هیچ بیمار با این جزئیات پیدا نشد.",
        "error": "خطای جستجو: {{message}}",
        "staff-assist": "با کارکنان تماس بگیرید",
        "not-found-prompt": "پیدا نشد؟",
        "register-new": "ثبت‌نام جدید",
        "not-found-hint": "No patient could be found with these details.",
        "create-new": "Register new patient",
        "dob-placeholder": "DD.MM.YYYY",
        "dob-picker": "Choose date of birth in the calendar",
        "title-v2": "پذیرش بدون کارت",
        "subtitle-firstname": "لطفاً نام کوچک خود را هم وارد کنید.",
        "ambiguous-firstname-v2": "چند نفر با این نام خانوادگی هستند. لطفاً نام کوچک خود را هم وارد کنید.",
        "search-again": "جستجوی دوباره",
        "found-v2": "شما را پیدا کردیم",
        "found-confirm": "لطفاً با «این من هستم» تأیید کنید.",
        "not-found-title": "شما را پیدا نکردیم",
        "not-found-check": "لطفاً املا و تاریخ تولد را بررسی کنید. پذیرش با کمال میل کمک می‌کند.",
        "not-found-reception": "لطفاً املا و تاریخ تولد را بررسی کنید یا به پذیرش مراجعه کنید.",
        "ambiguous-additional-v2": "نتوانستیم شما را به‌طور قطعی پیدا کنیم. لطفاً به پذیرش مراجعه کنید.",
        "error-v2": "جستجو فعلاً انجام نشد. لطفاً دوباره امتحان کنید."
      },
      "checking-in": {
        "title": "یک لحظه - ما شما را بررسی می کنیم.",
        "subtitle": "شما را به صف درمان اضافه می کنیم و به تیم اطلاع می دهیم.",
        "step-insurance": "بیمه بررسی شد",
        "step-appointment": "قرار ملاقات تایید شد",
        "step-waitlist": "اضافه شدن به لیست انتظار",
        "error": "ثبت نام انجام نشد. لطفا دوباره امتحان کنید.",
        "continue": "به هر حال ادامه بده",
        "title-v2": "لطفاً لحظه‌ای صبر کنید",
        "loading": "در حال پذیرش شما …",
        "subtitle-v2": "شما را در فهرست انتظار ثبت می‌کنیم و به کارکنان خبر می‌دهیم.",
        "error-title": "متأسفانه انجام نشد",
        "error-v2": "پذیرش شما کامل نشد.",
        "error-body": "لطفاً دوباره امتحان کنید. اگر باز هم نشد، پذیرش کمک می‌کند."
      },
      "appointment-selection": {
        "title": "قرار ملاقات را انتخاب کنید",
        "subtitle": "امروز چندین قرار ملاقات دارید. لطفا یکی را انتخاب کنید",
        "checking-in": "در حال بررسی...",
        "time": "{{time}}",
        "error-v2": "پذیرش برای این نوبت انجام نشد. لطفاً دوباره امتحان کنید یا به پذیرش مراجعه کنید."
      },
      "no-appointment": {
        "title": "قراری پیدا نشد",
        "subtitle": "امروز نتوانستیم برای شما قراری پیدا کنیم. لطفا یک قرار منظم رزرو کنید.",
        "book-appointment": "قرار ملاقات رزرو کنید",
        "book-appointment-description": "یک قرار جدید از طریق برنامه‌ریزی منظم رزرو کنید.",
        "staff-assist": "با کارکنان تماس بگیرید",
        "staff-assist-description": "به کمک نیاز دارم",
        "booking-disabled": "Appointment booking is currently unavailable",
        "booking-disabled-description": "Please contact the practice team to arrange an appointment.",
        "back-to-start": "Back to start",
        "subtitle-v2": "امروز نوبتی برای شما پیدا نکردیم.",
        "book-v2": "گرفتن نوبت جدید",
        "book-v2-description": "اکنون یک زمان آزاد انتخاب کنید.",
        "have-appointment": "نوبت دارم",
        "have-appointment-description": "پذیرش با کمال میل کمک می‌کند.",
        "unavailable-title": "لطفاً نوبت را در پذیرش بگیرید",
        "subtitle-unavailable": "امروز نوبتی برای شما پیدا نکردیم. لطفاً به پذیرش مراجعه کنید."
      },
      "staff-assist": {
        "title": "به کارکنان اطلاع داده شد",
        "subtitle": "یکی از کارکنان به زودی به شما کمک خواهد کرد.",
        "message": "لطفا اینجا منتظر بمانید یکی از کارکنان به زودی با شما خواهد بود.",
        "start-over": "بازگشت به شروع",
        "auto-redirect": "بازگشت به شروع در {{seconds}} ثانیه..."
      },
      "eeb-prompt": {
        "title": "تأیید بیمه",
        "title-failed": "تأیید ناموفق بود",
        "subtitle": "چگونه می‌خواهید بیمه خود را تأیید کنید؟",
        "subtitle-failed": "کد QR را با برنامه بیمه خود اسکن کنید تا درخواست تأیید ارسال شود.",
        "verify-card": "تأیید الکترونیکی",
        "verify-card-description": "ارسال درخواست به ارائه‌دهنده بیمه شما.",
        "select-insurer": "انتخاب بیمه‌گر",
        "select-insurer-description": "انتخاب دستی بیمه‌گر شما.",
        "skip": "رد شدن",
        "eyebrow-chip": "جایگزین",
        "eyebrow": "ورود · گواهی بیمه (eEB)",
        "recommended": "توصیه می شود",
        "qr-title": "با اپلیکیشن بیمه خود اسکن کنید",
        "qr-description": "برنامه بیمه درمانی خود را باز کنید و کد را اسکن کنید - eEB مستقیماً برای ما ارسال می شود.",
        "qr-address-label": "ارسال به",
        "title-app": "گواهی با برنامه",
        "subtitle-app": "بیمه شما می‌تواند گواهی را مستقیم برای ما بفرستد. وقتی تمام شد، روی «بعدی» بزنید."
      },
      "quarterly-check": {
        "title": "تأیید بیمه",
        "checking": "ما در حال بررسی تأیید بیمه فعلی شما هستیم...",
        "error": "بررسی انجام نشد.",
        "title-v2": "بیمه شما",
        "checking-v2": "در حال بررسی بیمه شما – لطفاً لحظه‌ای صبر کنید.",
        "error-body": "پذیرش شما کامل شده است. پذیرش موضوع بیمه را با شما روشن می‌کند."
      },
      "insurer-prefilled": {
        "title": "بیمه سلامت شما",
        "subtitle": "لطفاً بیمه خود را برای این فصل تأیید کنید.",
        "your-insurance": "بیمه شما",
        "last-read": "آخرین تأیید در {{date}}",
        "quarterly-notice": "برای اهداف صورتحساب، ما به اثبات فعلی بیمه برای این فصل نیاز داریم.",
        "confirm-button": "بله، این بیمه من است",
        "change-button": "بیمه متفاوتی دارم",
        "contact-title": "درخواست اثبات الکترونیکی پوشش",
        "contact-description": "با بیمه خود تماس بگیرید و یک گواهی الکترونیکی برای پوشش درخواست کنید:",
        "contact-patient": "بیمار",
        "contact-kim-address": "نشانی KIM مطب پزشک",
        "contact-phone": "تلفن",
        "question": "آیا این بیمه درمانی شماست؟",
        "quarterly-notice-v2": "هر سه ماه یک بار به گواهی بیمه درمانی شما نیاز داریم."
      },
      "insurer-search": {
        "title": "انتخاب بیمه سلامت",
        "subtitle": "لطفاً بیمه سلامت قانونی خود را جستجو و انتخاب کنید.",
        "placeholder": "جستجوی بیمه...",
        "hint": "حداقل 2 کاراکتر برای جستجو وارد کنید.",
        "no-results": "بیمه‌ای یافت نشد.",
        "no-results-hint": "املا را بررسی کنید یا جستجوی دیگری امتحان کنید.",
        "label": "نام بیمه درمانی شما",
        "search-error-v2": "جستجو فعلاً انجام نشد. لطفاً دوباره امتحان کنید.",
        "app-alternative": "ترجیح می‌دهید با برنامه بیمه خود؟"
      },
      "insurer-contact": {
        "title": "درخواست مدرک بیمه",
        "subtitle": "لطفا یکی از گزینه های زیر را انتخاب کنید.",
        "or": "یا",
        "option-eeb-title": "به صورت الکترونیکی درخواست کنید",
        "option-eeb-description": "اگر مورد استثنای قانونی وجود داشته باشد، می‌توانید پس از رضایت خود درخواست را به تیم مطب تحویل دهید.",
        "option-qr-title": "اسکن با برنامه",
        "option-qr-description": "QR code را با برنامه بیمه خود اسکن کنید.",
        "option-call-title": "خودت زنگ بزن",
        "option-call-description": "با بیمه خود تماس بگیرید و برای این مطب پزشک eEB درخواست کنید:",
        "phone": "تلفن",
        "phone-not-available": "شماره تلفن کارت بیمه شما",
        "patient-name": "بیمار",
        "practice-kim": "نشانی KIM مطب پزشک",
        "help-notice": "در صورت داشتن هر گونه مشکل به میز پذیرش مراجعه فرمایید.",
        "submit-eeb-button": "اکنون درخواست کنید",
        "contacted-button": "من تماس گرفته ام",
        "contacted-button-countdown": "زمان تماس شما ({{seconds}}s)",
        "go-to-counter-button": "به پذیرش بروید",
        "qr-continue-button": "من اسکن کرده ام",
        "qr-continue-button-countdown": "زمان اسکن ({{seconds}}s)",
        "title-v2": "گواهی بیمه درمانی شما",
        "subtitle-v2": "ساده‌ترین راه، برنامه بیمه شماست.",
        "subtitle-no-app": "لطفاً انتخاب کنید بیمه شما گواهی را چگونه برای ما بفرستد.",
        "option-eeb-description-v2": "ما از طرف شما از بیمه درخواست می‌کنیم. برای این کار به رضایت شما نیاز داریم.",
        "call-instruction": "با بیمه درمانی خود تماس بگیرید و بخواهید گواهی را به مطب ما بفرستند.",
        "call-instruction-practice": "با بیمه درمانی خود تماس بگیرید و بخواهید گواهی را به مطب {{practice}} بفرستند.",
        "done-button": "انجام شد – بعدی",
        "done-button-countdown": "انجام شد – بعدی ({{seconds}} ثانیه دیگر)"
      },
      "eeb-consent": {
        "title": "رضایت",
        "subtitle": "ما به رضایت شما برای تأیید الکترونیکی بیمه نیاز داریم.",
        "insurance": "بیمه شما",
        "consent-title": "رضایت برای تأیید الکترونیکی بیمه (eEB)",
        "consent-text": "من می‌دانم که بیمه درمانی من، داده‌های بیمه‌ام (مانند نام، تاریخ تولد، شماره بیمه) را از طریق سرویس ارتباطی امن KIM به مطب پزشک {{practiceName}} به عنوان مدرک بیمه ارسال خواهد کرد. با این انتقال موافقت می‌کنم. آگاه هستم که می‌توانم این رضایت را در هر زمان بدون تأثیر بر درمانم پس بگیرم.",
        "withdrawal-notice": "شما می‌توانید این رضایت را در هر زمان لغو کنید.",
        "agree-button": "موافقم",
        "decline-button": "لغو",
        "treatment-notice": "درمان شما تحت تأثیر این رضایت قرار نمی‌گیرد.",
        "load-failed": "The consent details could not be loaded. You can scan the QR code with your insurer app instead.",
        "not-available": "This request is not possible here right now. Please speak to reception.",
        "submit-failed": "Your consent could not be saved. Please try again or speak to reception.",
        "title-v2": "گواهی بیمه درمانی شما",
        "summary": "بیمه شما گواهی را مستقیم برای ما می‌فرستد. برای این کار به رضایت شما نیاز داریم.",
        "confirm-first": "لطفاً ابتدا اظهارنامه را تأیید کنید."
      },
      "qr-code": {
        "title": "با برنامه بیمه اسکن کنید",
        "instruction-1": "برنامه بیمه خود را باز کنید و این کد QR را اسکن کنید.",
        "instruction-2": "سپس مطب پزشک تأیید بیمه شما را به‌طور خودکار دریافت می‌کند.",
        "practice": "مطب پزشک: {{name}}",
        "alternative-hint": "جایگزین: از برنامه بیمه خود استفاده کنید",
        "instruction-app": "برنامه بیمه درمانی خود را باز کنید و این کد را اسکن کنید. گواهی مستقیم به ما می‌رسد.",
        "staff-line": "برای کارکنان مطب: {{address}}",
        "staff-line-practice": "برای کارکنان مطب: {{name}} · {{address}}",
        "alternative-app": "می‌توانید گواهی را با برنامه بیمه هم درخواست کنید: برنامه را باز کنید و این کد را اسکن کنید."
      },
      "register-basics": {
        "title": "اطلاعات شخصی",
        "subtitle": "لطفاً جزئیات خود را وارد کنید.",
        "family-name": "نام خانوادگی",
        "given-name": "نام",
        "dob": "تاریخ تولد",
        "gender": "جنسیت",
        "insurance-type": "نوع بیمه",
        "insurer-name": "نام بیمه شما",
        "insurer-name-placeholder": "به عنوان مثال Debeka، DKV، Allianz...",
        "gender-required": "لطفاً یک گزینه را انتخاب کنید."
      },
      "register-insurer": {
        "title": "بیمه سلامت",
        "subtitle": "لطفاً بیمه سلامت خود را انتخاب کنید.",
        "search-placeholder": "جستجوی بیمه..."
      },
      "register-details": {
        "title": "خلاصه",
        "subtitle": "لطفاً اطلاعات خود را بررسی کنید.",
        "create": "تکمیل ثبت‌نام",
        "missing-data": "لطفا تمام فیلدهای الزامی را پر کنید.",
        "create-error": "ثبت نام انجام نشد لطفا دوباره امتحان کنید.",
        "policy-number": "شماره خط مشی (اختیاری)",
        "policy-number-placeholder": "شماره خط مشی شما",
        "create-v2": "پایان پذیرش",
        "policy-number-hint": "شماره را روی کارت بیمه خود پیدا می‌کنید."
      },
      "diff-review": {
        "eyebrow-chip": "مرور کنید",
        "eyebrow": "ورود · اطلاعات کارت",
        "title": "مقایسه داده‌ها",
        "subtitle": "تفاوت‌هایی بین داده‌های کارت شما و سوابق ما یافت شد.",
        "col-current": "رکورد فعلی",
        "col-new": "جدید از کارت",
        "new-badge": "جدید",
        "field-fallback": "میدان",
        "note": "داده‌های به‌روزرسانی‌شده به ما کمک می‌کند صورت‌حساب را به‌درستی انجام دهیم و در مواقع اضطراری با شما تماس بگیریم.",
        "comparison-placeholder": "مقایسه اینجا نمایش داده می‌شود",
        "confirm": "تأیید تغییرات",
        "apply-error": "داده ها را نمی توان اعمال کرد. لطفا دوباره امتحان کنید.",
        "retry": "دوباره امتحان کنید",
        "skip": "به هر حال ادامه بده",
        "no-changes": "تغییری یافت نشد",
        "title-v2": "اطلاعات شما تغییر کرده است",
        "subtitle-v2": "روی کارت شما اطلاعات جدیدتری هست. آن‌ها را جایگزین کنیم؟",
        "confirm-v2": "جایگزینی و پذیرش",
        "keep": "پذیرش بدون تغییر",
        "col-current-v2": "قبلی",
        "col-new-v2": "جدید از کارت",
        "value-yes": "بله",
        "value-no": "خیر"
      },
      "insurance-selection": {
        "title": "نوع بیمه",
        "subtitle": "لطفاً نوع بیمه خود را انتخاب کنید.",
        "gkv": "بیمه قانونی",
        "gkv-description": "عضو بیمه سلامت قانونی.",
        "pkv": "خصوصی یا پرداخت شخصی",
        "pkv-description": "بیمه خصوصی یا پرداخت شخصی.",
        "pkv-description-v2": "بیمه درمانی خصوصی، یا خودتان پرداخت می‌کنید."
      },
      "eeb-request": {
        "title": "درخواست ثبت شد",
        "subtitle": "می‌توانید پذیرش خود را کامل کنید. پاسخ {{insurer}} بعداً به مطب می‌رسد.",
        "verifying": "درخواست شما برای پردازش فوری پذیرفته شد.",
        "success": "درخواست شما به‌صورت ایمن به تیم مطب تحویل داده شد.",
        "error": "تأیید درخواست در دسترس نیست.",
        "try-alternative": "روش جایگزین",
        "kim-load-error": "نشانی KIM مطب پزشک بارگیری نشد.",
        "kim-label": "مطب پزشک · KIM",
        "non-blocking-note": "این هنوز دریافت توسط بیمه درمانی شما یا وضعیت بیمه شما را تأیید نمی‌کند.",
        "auto-continue": "ادامه خودکار در {{seconds}} ثانیه.",
        "unavailable-title": "متأسفانه انجام نشد",
        "unavailable-v2": "درخواست شما به بیمه درمانی ثبت نشد.",
        "unavailable-body": "می‌توانید گواهی را با برنامه بیمه بفرستید یا موضوع را در پذیرش حل کنید.",
        "use-app": "با برنامه",
        "at-reception": "حل در پذیرش"
      },
      "self-pay": {
        "title": "پرداخت شخصی",
        "subtitle": "شما به عنوان بیمار با پرداخت شخصی درمان خواهید شد.",
        "info": "لطفاً توجه داشته باشید که شما مسئول هزینه‌های درمان خواهید بود.",
        "confirm": "متوجه شدم",
        "title-v2": "خودتان پرداخت می‌کنید",
        "subtitle-v2": "هزینه درمان را خودتان پرداخت می‌کنید.",
        "insured-after-all": "بیمه دارم"
      },
      "done": {
        "title": "انجام شد!",
        "subtitle": "ثبت‌نام شما کامل شد.",
        "finish": "پایان",
        "done-label": "انجام شد",
        "error-label": "توجه کنید",
        "eyebrow": "ورود · کامل شد",
        "queue-label": "اتاق انتظار",
        "queue-title": "لطفا بنشینید",
        "queue-meta": "ما شخصا با شما تماس خواهیم گرفت.",
        "success-title": "ثبت‌نام موفق!",
        "success-subtitle": "لطفاً در اتاق انتظار بنشینید. صدا زده خواهید شد.",
        "auto-redirect": "به زودی به صفحه اصلی هدایت خواهید شد...",
        "auto-redirect-countdown": "بازگشت به شروع در {{seconds}} ثانیه...",
        "card-expired-title": "کارت منقضی شده",
        "card-expired-subtitle": "کارت بیمه شما منقضی شده است.",
        "card-expired-info": "لطفاً برای کمک با کارکنان تماس بگیرید.",
        "back-to-start": "بازگشت به ابتدا",
        "anamnesis-title": "فرم کامل تاریخچه پزشکی",
        "anamnesis-description": "QR code را اسکن کنید تا فرم تاریخچه پزشکی خود را به راحتی در گوشی هوشمند خود پر کنید.",
        "title-confirm": "Thank you!",
        "subtitle-confirm": "You have confirmed your details. Your check-in is complete — please take a seat in the waiting room.",
        "title-saved": "Thank you!",
        "subtitle-saved": "Your changes have been processed. Reception will get in touch if anything is open. Please take a seat in the waiting room.",
        "title-skip": "Skipped",
        "subtitle-skip": "No problem — your check-in is complete. You can tell reception about changes at any time.",
        "title-v2": "پذیرش شما انجام شد",
        "card-expired-info-v2": "لطفاً به پذیرش مراجعه کنید."
      },
      "patient-info": {
        "loading": "Loading your contact details …",
        "review": {
          "title": "Review contact details",
          "intro": "Are these details still correct? The review is voluntary — your check-in is already complete.",
          "no-contacts": "No telephone numbers or email addresses are on file.",
          "all-correct": "Everything is correct",
          "skip": "Skip",
          "primary": "Primary",
          "protected": "Reception will review any change to this contact.",
          "reveal": "Show",
          "hide": "Hide",
          "type": {
            "MOBILEPRIV": "Mobile (private)",
            "PHONEPRIV": "Phone (private)",
            "MOBILEJOB": "Mobile (work)",
            "PHONEJOB": "Phone (work)",
            "EMAILPRIV": "Email (private)",
            "EMAILJOB": "Email (work)"
          },
          "save": "Save",
          "save-failed": "Could not save — please speak to reception.",
          "delete": "Delete",
          "undo": "Undo",
          "invalid": "Please check the format.",
          "add": "Add",
          "add-title": "Add a contact",
          "add-type": "Type",
          "add-value": "Enter a value",
          "hausarzt": "Family doctor / GP",
          "hausarzt-placeholder": "Enter a name or practice",
          "hausarzt-reception": "Reception will review any change to this information.",
          "hausarzt-invalid": "Enter no more than 120 characters.",
          "category": {
            "phone": "Phone",
            "email": "Email",
            "hausarzt": "Family doctor"
          },
          "category-empty": "Not on file",
          "primary-tag": "Main contact",
          "protected-chip": "Protected — reception reviews",
          "chip-direct": "Changes: saved directly",
          "chip-reception": "Changes: reception reviews",
          "chip-staged_one": "{{count}} change pending",
          "chip-staged_other": "{{count}} changes pending",
          "chip-will-add": "Will be added",
          "expand-phone_one": "Show {{count}} more number",
          "expand-phone_other": "Show {{count}} more numbers",
          "expand-email_one": "Show {{count}} more address",
          "expand-email_other": "Show {{count}} more addresses",
          "collapse-phone_one": "Hide additional number",
          "collapse-phone_other": "Hide additional numbers",
          "collapse-email_one": "Hide additional address",
          "collapse-email_other": "Hide additional addresses",
          "change": "Change",
          "close": "Close",
          "staged-removal": "Will be removed — value hidden",
          "stage-add": "Add to list",
          "add-more-phone": "Add another number",
          "add-more-email": "Add another address",
          "invalid-phone": "Please enter a valid phone number.",
          "invalid-email": "Please enter a valid email address.",
          "hausarzt-previous": "previously: {{value}}",
          "hausarzt-counter": "{{count}} / 120",
          "balance-total_one": "{{count}} change",
          "balance-total_other": "{{count}} changes",
          "balance-direct": "{{count}} saved directly",
          "balance-reception": "{{count}} reviewed by reception",
          "proposal-open": "Suggest a new address",
          "proposal-placeholder": "Your suggestion",
          "proposal-discard": "Discard",
          "proposal-hint": "Your suggestion goes to reception — the address is not changed immediately.",
          "title-v2": "بررسی اطلاعات شما",
          "balance-prefix": "هنگام ذخیره:",
          "balance-direct-v2": "فوراً ذخیره می‌شود: {{count}}",
          "balance-reception-v2": "پذیرش بررسی می‌کند: {{count}}",
          "chip-reception-v2": "تغییرات را پذیرش ما بررسی می‌کند",
          "chip-changed": "تغییر کرد: {{count}}",
          "remove": "حذف",
          "example-email": "مثلاً name@example.com",
          "example-phone": "مثلاً 0171 1234567",
          "intro-v2": "پذیرش شما کامل شده است. آیا این اطلاعات هنوز درست است؟ بررسی اختیاری است.",
          "auto-hide": "مقادیر نمایش‌داده‌شده پس از مدت کوتاهی دوباره پنهان می‌شوند."
        },
        "result": {
          "title": "Result",
          "continue": "Continue",
          "outcome": {
            "updated": "Updated",
            "satisfied": "Was already up to date",
            "task-created": "Sent to reception",
            "not-saved": "Not saved yet",
            "pending-retry": "Not saved yet"
          },
          "retry": "Try again",
          "removed": "Was removed",
          "cleared": "Was cleared",
          "task-note": "Nothing was overwritten — reception will get in touch if needed.",
          "not-saved-note": "Nothing was overwritten. Please speak to reception.",
          "banner-unfinished": "One detail has not been saved yet. You can try again directly on that row.",
          "banner-done": "Your details have been processed.",
          "footer": "All other details remain unchanged.",
          "task-note-v2": "این اطلاعات را به پذیرش منتقل کردیم.",
          "banner-done-v2": "سپاسگزاریم! اطلاعات شما به ما رسید.",
          "footer-v2": "همه اطلاعات دیگر بدون تغییر می‌مانند."
        },
        "expiry": {
          "notice": "For data protection reasons the review ends in 2 minutes. Your check-in stays complete.",
          "title": "The review has expired",
          "body": "For data protection reasons all displayed and entered values were deleted. Your check-in is still complete — you do not need to repeat anything. You can tell reception about changes at any time.",
          "continue": "To the summary",
          "body-v2": "به دلایل حفاظت از داده‌ها نمایش را بستیم. پذیرش شما با این حال کامل است. تغییرات را هر زمان می‌توانید به پذیرش اطلاع دهید."
        }
      },
      "progress": {
        "identify": "پذیرش",
        "insurance": "بیمه",
        "done": "انجام شد"
      },
      "dob-format-hint": "مثلاً 01.10.1980",
      "dob-required": "لطفاً تاریخ تولد خود را وارد کنید.",
      "insurance-label": {
        "GKV": "بیمه قانونی",
        "PKV": "بیمه خصوصی",
        "SELFPAY": "پرداخت شخصی"
      }
    },
    "emergency": {
      "title": "اورژانس حاد!",
      "label": "اورژانس",
      "subtitle": "این هشدار فقط به‌صورت محلی شنیده می‌شود و درخواست کمک نکرده است. در موارد حاد یا بالقوه تهدیدکننده زندگی با 112 تماس بگیرید.",
      "call-emergency": "تماس با خدمات اضطراری (112)",
      "stop-sound": "صدا را متوقف کنید",
      "play-sound": "پخش صدا",
      "back-to-start": "بازگشت به شروع",
      "headline": "لطفاً فوراً با کارکنان پذیرش صحبت کنید. در صورت خطر جانی با ۱۱۲ تماس بگیرید."
    },
    "help-reception": "کمک پذیرش",
    "help-reception-toast": "لطفا با پذیرش تماس بگیرید ما خوشحالیم که کمک می کنیم.",
    "language-entry": {
      "title": "زبان خود را انتخاب کنید"
    },
    "loading": "در حال بارگذاری…",
    "step-progress-label": "پیشرفت",
    "step-progress-phase": "بخش {{current}} از {{total}}: {{phase}}",
    "step-progress-substep": "قسمت {{current}} از {{total}}",
    "step-progress-complete": "تکمیل شد",
    "identification": {
      "title": "شما چه کسی هستید؟",
      "lead": "سریع‌ترین راه کارت بیمه درمانی شماست. می‌توانید با نام خود هم جستجو کنید.",
      "lead-card-only": "لطفاً کارت بیمه درمانی خود را در کارت‌خوان قرار دهید.",
      "mode-label": "چگونه می‌خواهید وارد شوید؟",
      "mode-card": "با کارت",
      "mode-search": "جستجو با نام",
      "mode-create": "جدید در مطب",
      "card": {
        "loading": "در حال آماده‌سازی کارت‌خوان …",
        "checking": "در حال بررسی کارت‌خوان …",
        "insert-title": "لطفاً کارت بیمه درمانی خود را در کارت‌خوان قرار دهید.",
        "insert-detail": "اطلاعات شما را به‌طور خودکار می‌خوانیم.",
        "detected": "کارت شناسایی شد",
        "read": "خواندن کارت",
        "reading": "در حال خواندن کارت …",
        "reading-hint": "لطفاً کارت را در دستگاه نگه دارید.",
        "no-terminal-title": "کارت‌خوان در دسترس نیست",
        "help-with-search": "لطفاً با نام خود جستجو کنید یا از پذیرش بپرسید.",
        "help-reception": "لطفاً از پذیرش بپرسید – با کمال میل کمک می‌کنیم.",
        "unreadable-title": "کارت شناسایی شد اما قابل خواندن نیست",
        "error-title": "کارت خوانده نشد",
        "not-unique": "نتوانستیم شما را به‌طور قطعی با این کارت تطبیق دهیم. لطفاً با نام خود جستجو کنید یا از پذیرش بپرسید.",
        "no-match": "برای این کارت اطلاعاتی پیدا نکردیم. لطفاً با نام خود جستجو کنید یا از پذیرش بپرسید.",
        "without-card": "ادامه بدون کارت"
      },
      "lookup": {
        "lead": "لطفاً نام خانوادگی و تاریخ تولد خود را وارد کنید.",
        "first-name": "نام",
        "last-name": "نام خانوادگی",
        "dob": "تاریخ تولد",
        "dob-hint": "قالب: روز.ماه.سال",
        "search": "جستجو",
        "confirm": "بله، خودم هستم",
        "found-title": "شما را پیدا کردیم",
        "found-body": "لطفاً تأیید کنید که این شما هستید.",
        "first-name-needed-title": "لطفاً نام خود را اضافه کنید",
        "first-name-needed-body": "تا شما را به‌طور قطعی پیدا کنیم. سپس روی «جستجو» بزنید.",
        "ambiguous-title": "نتوانستیم شما را به‌طور قطعی پیدا کنیم",
        "ambiguous-body": "لطفاً از پذیرش بپرسید – با کمال میل کمک می‌کنیم.",
        "not-found-title": "اطلاعات مطابقی پیدا نشد",
        "not-found-body": "لطفاً اطلاعات وارد شده را بررسی کنید.",
        "error-title": "جستجو در حال حاضر ممکن نیست",
        "error-body": "لطفاً دوباره تلاش کنید یا از پذیرش بپرسید."
      },
      "create": {
        "insurance-question": "بیمه شما چیست؟",
        "insurance-required": "لطفاً نوع بیمه خود را انتخاب کنید.",
        "error-title": "اطلاعات شما ذخیره نشد",
        "error-body": "لطفاً دوباره تلاش کنید یا از پذیرش بپرسید."
      }
    }
  },
  "onboarding": {
    "prepare": {
      "title": "ابتدا قفل را باز کنید",
      "subtitle": "FrontDesk+ باید در نرم افزار تمرین شما فعال شود.",
      "step1": "در SolStore سفارش دهید (یا شریک Doc-Cirrus شما برای شما سفارش می دهد).",
      "step2": "پس از فعال سازی، در inSuite Sols در زیر \"inSuite Sols\" (حقوق مدیریت) فعال کنید.",
      "step3": "مدیریت Bridge → \"افزودن دستگاه\" را باز کنید.",
      "cta": "همه چیز تمام شد - ادامه دهید"
    },
    "welcome": {
      "title": "این دستگاه را به تمرین اضافه کنید",
      "scan": "از کدها عکس بگیرید",
      "prepare-link": "کدی در inSuite وجود ندارد؟",
      "language": "زبان"
    },
    "scan": {
      "requesting": "دسترسی به دوربین درخواست شده است…",
      "scanning": "دوربین را به سمت کد بگیرید",
      "paste": "به جای آن چسب بزنید",
      "manual-title": "به صورت دستی وصل شوید",
      "manual-description": "اگر کد QR در دسترس نیست، داده های اتصال را از مدیریت Bridge بگیرید.",
      "address-label": "آدرس Bridge",
      "address-placeholder": "https://…/_rest_",
      "soltoken-label": "SOLTOKEN",
      "soltoken-placeholder": "SOLTOKEN را درج کنید",
      "manual-submit": "اتصال را در دست بگیرید",
      "error-title": "کد شناسایی نشد",
      "camera-denied-title": "دسترسی به دوربین ممنوع شد",
      "camera-denied-hint": "لطفاً در تنظیمات اجازه دسترسی به دوربین را بدهید و دوباره امتحان کنید.",
      "retry": "دوباره امتحان کنید"
    },
    "preflight": {
      "title": "راه اندازی خواهد شد",
      "all-green": "تمام تست ها قبول شد",
      "practice": "تمرین کنید",
      "device-name": "نام دستگاه",
      "device-name-placeholder": "به عنوان مثال ب. پذیرایی 1",
      "card-reader": "کارتخوان",
      "pin": "شماره سری جدید",
      "pin-placeholder": "پین چهار رقمی",
      "finish": "پایان",
      "recheck": "دوباره چک کنید",
      "diagnosis": "شناسه تشخیص",
      "checklist-error": "Bridge اتصال را رد کرد یا در دسترس نیست. SOLTOKEN و نشانی Bridge را بررسی کنید.",
      "checklist-retry": "بررسی دوباره",
      "edit-token": "تغییر SOLTOKEN",
      "rescan": "اسکن دوباره کد"
    },
    "persisting": "در حال ذخیره تنظیمات …",
    "success": {
      "title": "دستگاه اضافه شد",
      "detail": "دستگاه به تازگی بر روی رایانه شخصی تمرین ظاهر شده است.",
      "starting": "حالت بیمار شروع می شود…"
    },
    "checklist": {
      "general_api_unavailable": {
        "label": "اتصال به نرم افزار تمرین",
        "fix": "Bridge اتصال و آدرس سرور را بررسی کنید."
      },
      "missing_insuite_url": {
        "label": "آدرس inSuite",
        "fix": "دوباره کد QR را اسکن کنید - آدرس موجود نیست."
      },
      "missing_server_token": {
        "label": "توکن سرور",
        "fix": "کد QR را دوباره اسکن کنید - رمز موجود نیست."
      },
      "missing_gateway_session": {
        "label": "جلسه Gateway",
        "fix": "دوباره وارد شوید - جلسه از دست رفته است."
      },
      "missing_gateway_enrollment": {
        "label": "ثبت دستگاه",
        "fix": "دستگاه را در Gateway ثبت کنید."
      },
      "gateway_not_ready": {
        "label": "آمادگی Gateway",
        "fix": "منتظر بمانید تا Gateway راه اندازی را کامل کند."
      },
      "token_verification_failed": {
        "label": "چک توکن",
        "fix": "رمز سرور یا اتصال Bridge را بررسی کنید."
      },
      "session_expired": {
        "label": "جلسه",
        "fix": "جلسه منقضی شده است - دوباره وارد شوید."
      },
      "device_revoked": {
        "label": "وضعیت دستگاه",
        "fix": "این دستگاه مسدود شده است. با مطب تماس بگیرید"
      },
      "missing_practice_name": {
        "label": "نام تمرین",
        "fix": "نام عمل پزشکی بارگیری نشد (inSuite)."
      },
      "missing_device_name": {
        "label": "نام دستگاه",
        "fix": "لطفاً یک نام دستگاه وارد کنید."
      },
      "telematik_unavailable": {
        "label": "زیرساخت های مخابراتی",
        "fix": "اختیاری - بررسی کارت به محض در دسترس بودن TI امکان پذیر است."
      },
      "selected_card_reader_unavailable": {
        "label": "کارتخوان",
        "fix": "اختیاری — یک کارت خوان را انتخاب یا وصل کنید."
      },
      "medical_card_unavailable": {
        "label": "SMC-B / HBA",
        "fix": "اختیاری - کارت اعتبار پزشکی را وارد کنید (SMC-B)."
      }
    },
    "token": {
      "title": "SOLTOKEN را وارد کنید",
      "description": "به دلایل امنیتی، کد QR شامل SOLTOKEN نیست. آن را در inSuite در بخش «Sol-Aktivierung» (FrontDesk+) کپی کرده و اینجا قرار دهید.",
      "submit": "ادامه",
      "rescan": "اسکن دوباره کد"
    }
  }
}
